export const validateInputNumber = (event: KeyboardEvent) => {
  return (
    event.ctrlKey ||
    event.altKey ||
    (47 < event.keyCode && event.keyCode < 58 && event.shiftKey === false) ||
    (95 < event.keyCode && event.keyCode < 106) ||
    event.keyCode === 8 ||
    event.keyCode === 9 ||
    (event.keyCode > 34 && event.keyCode < 40) ||
    event.keyCode === 46
  );
};

export const numberOnlyDirective = {
  mounted(el: HTMLElement) {
    const inputEl = el.querySelector('input') as HTMLInputElement;

    if (inputEl) {
      inputEl.addEventListener('keydown', (e) => {
        // const target = e.target as HTMLTextAreaElement;
        const isValidInput = validateInputNumber(e);
        if (!isValidInput) {
          e.preventDefault();
          return;
        }
      });
      inputEl.addEventListener('blur', (e) => {
        const value = parseInt(inputEl.value);
        if (!validateMin(inputEl, value)) {
          inputEl.value = '';
          inputEl.dispatchEvent(new Event('input'));
          e.preventDefault();
        }

        if (!validateMax(inputEl, value)) {
          inputEl.value = '';
          inputEl.dispatchEvent(new Event('input'));
          e.preventDefault();
        }
      });

      inputEl.addEventListener('paste', (e) => {
        const pastedText = e.clipboardData?.getData('text/plain');

        // Check if the pasted text is an integer
        if (pastedText && !/^\d+$/.test(pastedText)) {
          e.preventDefault();
          return;
        }
        if (pastedText) {
          const value = parseInt(inputEl.value + pastedText);

          if (!validateMin(inputEl, value)) {
            e.preventDefault();
          }

          if (!validateMax(inputEl, value)) {
            e.preventDefault();
          }
        }
      });
    }
  },
};

const validateMin = (inputEl: HTMLElement, value: number) => {
  if (inputEl.hasAttribute('min')) {
    const min = parseInt(inputEl.getAttribute('min') ?? '');

    if (min && value < min) {
      return false;
    }
  }
  return true;
};

const validateMax = (inputEl: HTMLElement, value: number) => {
  if (inputEl.hasAttribute('max')) {
    const max = parseInt(inputEl.getAttribute('max') ?? '');

    if (max && value > max) {
      return false;
    }
  }
  return true;
};
